export const FETCH_VOICES = 'FETCH_VOICES';
